<template>
  <div class="flex flex-col col-span-2 gap-y-4">
    <nav
      id="tabs-historial"
      class="relative z-0 flex border rounded-xl overflow-hidden dark:border-gray-700"
      aria-label="Tabs"
      role="tablist"
    >
      <button
        id="bar-with-underline-item-1"
        type="button"
        class="hs-tab-active:border-b-blue-600 hs-tab-active:text-gray-900 dark:hs-tab-active:text-white dark:hs-tab-active:border-b-blue-600 relative min-w-0 flex-1 bg-white first:border-s-0 border-s border-b-2 py-4 px-4 text-gray-500 hover:text-gray-700 text-sm font-medium text-center overflow-hidden hover:bg-gray-50 focus:z-10 focus:outline-none focus:text-blue-600 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-800 dark:border-l-gray-700 dark:border-b-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-400 active cursor-pointer"
        data-hs-tab="#bar-with-underline-1"
        aria-controls="bar-with-underline-1"
        role="tab"
        @click="loadTab(1)"
      >
        Citas
      </button>
      <button
        id="bar-with-underline-item-2"
        type="button"
        class="hs-tab-active:border-b-blue-600 hs-tab-active:text-gray-900 dark:hs-tab-active:text-white dark:hs-tab-active:border-b-blue-600 relative min-w-0 flex-1 bg-white first:border-s-0 border-s border-b-2 py-4 px-4 text-gray-500 hover:text-gray-700 text-sm font-medium text-center overflow-hidden hover:bg-gray-50 focus:z-10 focus:outline-none focus:text-blue-600 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-800 dark:border-l-gray-700 dark:border-b-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-400 cursor-pointer"
        data-hs-tab="#bar-with-underline-2"
        aria-controls="bar-with-underline-2"
        role="tab"
        @click="loadTab(2)"
      >
        Labs
      </button>
      <button
        id="bar-with-underline-item-3"
        type="button"
        class="hs-tab-active:border-b-blue-600 hs-tab-active:text-gray-900 dark:hs-tab-active:text-white dark:hs-tab-active:border-b-blue-600 relative min-w-0 flex-1 bg-white first:border-s-0 border-s border-b-2 py-4 px-4 text-gray-500 hover:text-gray-700 text-sm font-medium text-center overflow-hidden hover:bg-gray-50 focus:z-10 focus:outline-none focus:text-blue-600 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-800 dark:border-l-gray-700 dark:border-b-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-400 cursor-pointer"
        data-hs-tab="#bar-with-underline-3"
        aria-controls="bar-with-underline-3"
        role="tab"
        @click="loadTab(3)"
      >
        Proc
      </button>
      <button
        id="bar-with-underline-item-4"
        type="button"
        class="hs-tab-active:border-b-blue-600 hs-tab-active:text-gray-900 dark:hs-tab-active:text-white dark:hs-tab-active:border-b-blue-600 relative min-w-0 flex-1 bg-white first:border-s-0 border-s border-b-2 py-4 px-4 text-gray-500 hover:text-gray-700 text-sm font-medium text-center overflow-hidden hover:bg-gray-50 focus:z-10 focus:outline-none focus:text-blue-600 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-800 dark:border-l-gray-700 dark:border-b-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-400 cursor-pointer"
        data-hs-tab="#bar-with-underline-4"
        aria-controls="bar-with-underline-4"
        role="tab"
        @click="loadTab(4)"
      >
        Anexos
      </button>
    </nav>
    <div class="p-4 bg-white min-h-48 dark:bg-gray-800 dark:text-gray-400">
      <div
        id="bar-with-underline-1"
        role="tabpanel"
        aria-labelledby="bar-with-underline-item-1"
      >
        <div
          class="flex-none min-w-full px-4 sm:px-6 md:px-0 overflow-hidden lg:overflow-auto scrollbar:!w-1.5 scrollbar:!h-1.5 scrollbar:bg-transparent scrollbar-track:!bg-slate-100 scrollbar-thumb:!rounded scrollbar-thumb:!bg-slate-300 scrollbar-track:!rounded dark:scrollbar-track:!bg-slate-500/[0.16] dark:scrollbar-thumb:!bg-slate-500/50 max-h-[500px] lg:supports-scrollbars:pr-2 lg:max-h-[500px]"
        >
          <AgendamientoListar
            v-if="loadedTabs.includes(1) && persona.copeId != null"
            :copp-id="persona.copeId"
            :tipo="'CONSULTA'"
            :exclude-filters="['ciadTipoEstado']"
          />
        </div>
      </div>
      <div
        id="bar-with-underline-2"
        class="hidden"
        role="tabpanel"
        aria-labelledby="bar-with-underline-item-2"
      >
        <div
          class="flex-none min-w-full px-4 sm:px-6 md:px-0 overflow-hidden lg:overflow-auto scrollbar:!w-1.5 scrollbar:!h-1.5 scrollbar:bg-transparent scrollbar-track:!bg-slate-100 scrollbar-thumb:!rounded scrollbar-thumb:!bg-slate-300 scrollbar-track:!rounded dark:scrollbar-track:!bg-slate-500/[0.16] dark:scrollbar-thumb:!bg-slate-500/50 max-h-[500px] lg:supports-scrollbars:pr-2 lg:max-h-[500px]"
        >
          <AgendamientoListar
            v-if="loadedTabs.includes(2) && persona.copeId != null"
            :copp-id="persona.copeId"
            :tipo="'LABORATORIO'"
            :exclude-filters="['ciadTipoEstado']"
          />
        </div>
      </div>
      <div
        id="bar-with-underline-3"
        class="hidden"
        role="tabpanel"
        aria-labelledby="bar-with-underline-item-3"
      >
        <div
          class="flex-none min-w-full px-4 sm:px-6 md:px-0 overflow-hidden lg:overflow-auto scrollbar:!w-1.5 scrollbar:!h-1.5 scrollbar:bg-transparent scrollbar-track:!bg-slate-100 scrollbar-thumb:!rounded scrollbar-thumb:!bg-slate-300 scrollbar-track:!rounded dark:scrollbar-track:!bg-slate-500/[0.16] dark:scrollbar-thumb:!bg-slate-500/50 max-h-[500px] lg:supports-scrollbars:pr-2 lg:max-h-[500px]"
        >
          <AgendamientoListar
            v-if="loadedTabs.includes(3) && persona.copeId != null"
            :copp-id="persona.copeId"
            :tipo="'PROCEDIMIENTO'"
            :exclude-filters="['ciadTipoEstado']"
          />
        </div>
      </div>
      <div
        id="bar-with-underline-4"
        class="hidden"
        role="tabpanel"
        aria-labelledby="bar-with-underline-item-4"
      >
        <Anexos
          v-if="loadedTabs.includes(4) && persona.copeId != null"
          :copp-id="persona.copeId"
          :technologias="technologias"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, ref } from 'vue'
import AgendamientoListar from '@/modules/Agendamiento/components/AgendamientoListar.vue'
import Anexos from '@/modules/Administracion/components/AnexosDefault.vue'

import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'
import type { IConfPersonasPaciente } from '@/modules/Administracion/interfaces'

const props = defineProps<{
  persona: IConfPersonasPaciente
  technologias?: ICitaTechnologiasSalud[]
}>()

const { persona, technologias } = props
const loadedTabs = ref([1])
const loadTab = (tab: number) => {
  if (!loadedTabs.value.includes(tab)) loadedTabs.value.push(tab)
}

onMounted(async () => {
  await nextTick()
  const tab = document.querySelector('#tabs-historial')
  if (tab) new window.HSTabs(tab)
})
</script>
